import React from 'react';
import { ReactComponent } from 'Common/components/Icons/template.svg';

const Template = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Template;
